import { GButton } from 'components/basic-blocks'

import { HeaderProps } from './types'

export const Header = ({ handleSave, loading }: HeaderProps) => {
	return (
		<header>
			<div className="flex align-middle justify-between">
				<strong className="font-medium text-color-text-default text-xl">
					AI protection
				</strong>
				<GButton
					label="Save changes"
					variant="contained"
					color="yellow"
					labelClassName="font-medium text-base"
					className="h-[30px] w-max rounded-full disabled:!shadow-none !shadow-s-yellow"
					onClick={handleSave}
					loading={loading}
				/>
			</div>
			<span className="text-t-checkbox-unactive max-w-[300px] block font-base leading-5">
				Automated protection using ClickGUARD’s machine learning model
			</span>
		</header>
	)
}
